import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-item-drag",
  "use": "icon-item-drag-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-item-drag\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 288l1024 0 0 64-1024 0 0-64Z\" p-id=\"4819\" /><path d=\"M0 480l1024 0 0 64-1024 0 0-64Z\" p-id=\"4820\" /><path d=\"M0 672l1024 0 0 64-1024 0 0-64Z\" p-id=\"4821\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/item-drag.svg
// module id = oo//
// module chunks = 101